<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <!-- <v-btn
          text
          :href="`${mediaUrl} `"
          rounded
          color="primary"
          target="_blank"
        >
          <v-icon>mdi-download</v-icon>
          Download sample file
        </v-btn> -->
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Upload Old User Used Point
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-if="crud_old_user_used_points.length == 0">
              <input
                type="file"
                id="file"
                name="file"
                ref="file"
                accept="application/ms-excel"
                multiple
                @input="handleFileUpload"
              />
              <section v-if="isUploading">
                <v-progress-linear
                  class="mt-5"
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
            </v-col>
            <v-col v-else>
              <v-btn
                color="success"
                :loading="isProcessing"
                :disabled="isProcessing"
                @click="processFile"
              >
                Upload file</v-btn
              >

              &nbsp;
              <v-btn color="error" @click="truncatePendingDocuments">
                Delete
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <span style="color: red" v-show="isError">{{ error_msg }} </span>
          </v-row>
        </v-card-text>
      </v-card>
      <br />
      <v-card elevation="6" rounded="xxl">
        <v-card-text>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="min-width: 130px">Date</th>
                  <th class="text-left" style="min-width: none">Phone</th>
                  <th class="text-left" style="min-width: none">Points</th>
                  <th class="text-left" style="min-width: none">
                    Product Purchased
                  </th>
                  <th class="text-right action_th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    crud_old_user_used_point, at
                  ) in crud_old_user_used_points"
                  :key="`crud_old_user_used_point${at}`"
                >
                  <td>
                    {{ crud_old_user_used_point.date || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_used_point.phone || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_used_point.points || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_used_point.product || "" }}
                  </td>
                  <td class="text-right">
                    <template>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            fab
                            x-small
                            class="my-auto"
                            color="error"
                            @click="handleStatus(crud_old_user_used_point)"
                          >
                            <v-icon dark> mdi-delete </v-icon>
                          </v-btn>
                        </template>
                        <span>Delete this Old User Used Point</span>
                      </v-tooltip>
                    </template>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <!-- Upload Success Dialog Box -->
      <v-dialog v-model="is_Uploaded" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-cloud-upload-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been uploaded successfully. Now you can
                        Preview the List & process accordingly.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Uploaded = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Process Success Dialog Box -->
      <v-dialog v-model="is_Processed" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-progress-download
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been processed successfully. Now you can
                        see your users in User's Tab.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Processed = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Truncate Success Dialog Box -->
      <v-dialog v-model="is_Truncated" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: red; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: red">Deleted!</h1>
                      <br />
                      <h3>
                        The file has been deleted successfully. Now you can
                        select a new file to upload.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Truncated = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Confirmation Dialog Component -->
      <ConfirmationDialog
        :show.sync="dialog"
        :title="dialogTitle"
        :message="dialogMessage"
        :icon="dialogIcon"
        :color="dialogColor"
        @confirm="confirmApproval"
      />
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
export default {
  components: { ConfirmationDialog },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Upload User Excel",
  },
  data() {
    return {
      crud_old_user_used_points: [],
      isLoading: false,
      isUploading: false,
      is_Uploaded: false,
      isProcessing: false,
      is_Processed: false,
      is_Truncated: false,
      isError: false,
      error_msg: "",
      path: "",

      selectedUserDataId: null,
      dialog: false,
      dialogTitle: "",
      dialogMessage: "",
      dialogIcon: "",
      dialogColor: "",

      calculatedPoints: [],
      selectedPhones: [],
      showCalculatedDialog: false,
      calculatedHeaders: [
        { text: "Phone", value: "phone" },
        { text: "Total Points", value: "total_quantity" },
        // { text: "Count", value: "count" },
        { text: "Status", value: "status" },
      ],
    };
  },
  watch: {
    selectedPhones(val) {
      console.log("Selected phones:", val);
    },
  },
  mounted() {
    this.getData();
    this.path = this.mediaUrl;
    console.log(this.path);
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      try {
        await axios
          .get(`/crud_old_user_used_points`)
          .then((crud_old_user_used_points) => {
            this.crud_old_user_used_points =
              crud_old_user_used_points.data.data;
            this.count = crud_old_user_used_points.data.count;
            this.serialNoStarting = (page - 1) * this.rowsPerPage;
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            // window.location.href = "/auth/login";ss
          });
      } catch (error) {
        console.log(error);
      }
    },
    async handleFileUpload() {
      this.isUploading = true;
      this.isUploadingError = false;
      this.error_msg = "";
      this.users = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("users", this.users);
      this.changeValue = 100;
      await axios
        .post("crud_old_user_used_points/upload_user", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data)
            this.crud_old_user_used_points = response.data.data;
          this.is_Uploaded = true;
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
      this.isUploading = false;
    },
    async processFile() {
      try {
        this.isProcessing = true;
        await axios.get(`crud_old_user_used_points/process_user`).catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while processing the File. Kindly check the file before processing ...";
        });
        this.isProcessing = false;
        this.is_Processed = true;
        await axios.get("crud_old_user_used_points/truncate_users");
        this.crud_old_user_used_points = [];
        // alert("Processed Successfully");
      } catch (e) {
        console.log(e);
      }
    },
    async truncatePendingDocuments() {
      try {
        await axios.get("crud_old_user_used_points/truncate_users");
        this.is_Truncated = true;
        this.crud_old_user_used_points = [];
      } catch (error) {
        console.log(error);
      }
    },
    handleStatus(data) {
      this.dialogTitle = "Delete Data";
      this.dialogMessage = "Are you sure you want to delete this user data?";

      this.dialogIcon = "mdi-alert-circle-outline";

      this.dialogColor = "red";

      this.selectedUserDataId = data.id;
      this.dialog = true; // Open dialog
    },
    async confirmApproval() {
      await axios
        .post(
          `/crud_old_user_used_points/delete/${this.encryptIt(
            this.selectedUserDataId
          )}`
        )
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  min-width: 130px !important;
}
</style>
